import React from "react";
import { useStyles } from "../style";
import { TextField } from "@mui/material";
import { getTranslateByKey } from "@/main/services/utils";
import { TextFieldXnuupPartIdProps } from "../interfaces";

export const TextFieldXnuupPartIdComponent = React.forwardRef(
	(
		{
			params,
			required,
			propsCustom: { label, setInputText, hasBorderStyle },
			hasErrorCustom,
			errorMessageCustom,
		}: TextFieldXnuupPartIdProps,
		ref: React.Ref<TextFieldXnuupPartIdProps>,
	) => {
		// Styles
		const classes = useStyles();

		const placeholderText = `${getTranslateByKey("information.search")} ${label.toLowerCase()}...`;
		return (
			<TextField
				{...params}
				onChange={(e) => {
					setInputText(e.target.value);
				}}
				label={label}
				required={required}
				placeholder={placeholderText}
				variant="filled"
				className={classes.inputText}
				style={hasBorderStyle ? { border: "2px solid #dedede" } : {}}
				id="id-xnuupPartId-txt-field"
				error={!!hasErrorCustom}
				helperText={errorMessageCustom}
				ref={ref}
			/>
		);
	},
);
